import React, { useState, useEffect } from 'react';
import SelectSearch from 'react-select-search';
import './styles.scss';

const SearchSelect = ({ options, label = "Seleccionar UF", onChange, value }) => {

    const [unidadesSelect, setUnidadesSelect] = useState([]);
    useEffect(() => {
        if (options && options.length > 0) {
            setUnidadesSelect(options.map(function (unidad) {
                return { value: unidad.unidad, name: 'UF ' + unidad.unidad + ' - ' + unidad.alias + ' - ' + unidad.direccion }
            }));
        }
    }, [options]);
    
    
    return <SelectSearch
        options={unidadesSelect}
        search
        printOptions="auto"
        emptyMessage={() => <div className="select-search_emptymessage">No se encontró UF</div>}
        placeholder={label}
        onChange={onChange}
        value={value.unidad}
    />
}

export default SearchSelect;